export const inputActionType = {
  copy: 'copy',
  paste: 'paste'
}
